import React from 'react';
import { motion } from 'framer-motion';

interface PriceCardProps {
  title: string;
  price: string;
  highlight?: boolean;
}

const PriceCard: React.FC<PriceCardProps> = ({ title, price, highlight = false }) => {
  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className={`relative p-4 md:p-6 lg:p-8 transition-all duration-500 overflow-hidden h-full flex flex-col justify-between ${
        highlight
          ? 'luxury-card bg-white text-luxury-black border-2 border-luxury-gold'
          : 'luxury-card hover:border-luxury-gold/40'
      }`}
    >
      <div className="relative z-10 flex flex-col h-full">
        <h3 className={`text-sm md:text-base lg:text-lg font-body tracking-wide mb-auto pb-3 md:pb-4 ${
          highlight ? 'text-luxury-black' : 'text-luxury-gray-dark'
        }`}>
          {title}
        </h3>

        <div>
          <div className="flex items-baseline gap-1">
            <span className={`text-sm ${highlight ? 'text-luxury-gold' : 'text-luxury-gray'}`}>
              {price.replace('€', '').match(/[0-9]/) ? '€' : ''}
            </span>
            <p className={`text-2xl md:text-3xl lg:text-4xl font-display ${
              highlight ? 'text-luxury-gold' : 'text-luxury-black'
            }`}>
              {price.replace('€', '')}
            </p>
          </div>

          {highlight && (
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: '50px' }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="h-px bg-luxury-gold mt-4"
            />
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default PriceCard;